/**
 * @file
 * A JavaScript file containing the activate-target functionality
 */

(function (Drupal, $) {
  Drupal.behaviors.inViewport = {
    attach: function (context) {
      "use strict";

      var targetElements = document.querySelectorAll(".out-of-viewport");

      function checkInViewport() {
        for (var i = 0; i < targetElements.length; i++) {
          var top = targetElements[i].getBoundingClientRect().top;
          if (top < window.outerHeight - 50) {
            targetElements[i].classList.remove("out-of-viewport");
            targetElements[i].classList.add("in-viewport");
          } else {
            targetElements[i].classList.add("out-of-viewport");
            targetElements[i].classList.remove("in-viewport");
          }
        }
      }

      checkInViewport();

      document.addEventListener("scroll", checkInViewport);
    },
  };
})(Drupal, jQuery);
